import axios from "axios";

let jwt;

const articleWhitelist = ["articleID", "price", "uvp"];

export function setToken(token) {
  jwt = token;
}

export function destroyToken() {
  jwt = null;
  localStorage.removeItem("token");
}

const getToken = () => {
  if (!jwt && !localStorage.getItem("token")) return null;
  return jwt || JSON.parse(localStorage.getItem("token"));
};

const only = (obj, keys) => {
  return Object.keys(obj).reduce((acc, curr) => {
    if (!keys.includes(curr)) return acc;
    return {
      ...acc,
      [curr]: obj[curr]
    };
  }, {});
};

const createAPIClient = ({ baseURL }) => {
  const clientInstance = axios.create({
    baseURL
  });

  return {
    contact: ({ textMessage, clientID, token = getToken() }) => {
      return clientInstance.post(
        "/contact",
        {
          clientID,
          textMessage
        },
        {
          params: {
            token
          }
        }
      );
    },

    logout: ({ token }) => {
      return new Promise(res => setTimeout(res, 500));
    },
    login: ({ clientID, password }) =>
      clientInstance.post("/login", {
        clientID,
        password
      }),
    checkout: ({ cart, client, token = getToken() }) => {
      const remappedCart = cart.map(item => only(item, articleWhitelist));
      return clientInstance.post(
        "/checkout",
        { cart: remappedCart, client },
        {
          params: {
            token
          }
        }
      );
    }
  };
};

export default createAPIClient;



// WEBPACK FOOTER //
// ./src/api/api.js